import { render, staticRenderFns } from "./ImportCSVTable.vue?vue&type=template&id=21a494c6&scoped=true&"
import script from "./ImportCSVTable.vue?vue&type=script&lang=ts&"
export * from "./ImportCSVTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a494c6",
  null
  
)

export default component.exports